import dayjs from "dayjs";
import "dayjs/plugin/utc";
import enrollmentServices from "../../Services/enrollmentServices";
import moment from "moment";
import { Base64 } from "js-base64";
import { Buffer } from "buffer";
import sha256 from "crypto-js/sha256";
import PaymentService from "../../Services/PaymentService";
import { message } from "antd";
import axios from "axios";
import AppointmentService from "../../Services/AppointmentService";
import ConsultationService from "../../Services/ConsultationService";
dayjs.extend(require("dayjs/plugin/utc"));

class commonFunctions {
  convertUTCDate(date, format) {
    if (!format) {
      var d = new Date();
      date = new Date(
        dayjs(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return dayjs(date).utc().format(format);
  }

  ConvertTime(time) {
    const timePart = time.format("HH:mm");
    return `${timePart}`;
  }

  convertDate = (date) => {
    const datePart = dayjs(date, "MM-DD-YYYY").format("MM/DD/YYYY");
    const time = `${datePart}`;
    return time;
  };

  getFormOpenTime = (fromTime) => {
    const currentFormOpenStartTime = fromTime
      ? fromTime
      : localStorage.getItem("currentFormOpenStartTime");
    const currentDateTime = new Date();

    const ms = moment(currentDateTime, "DD/MM/YYYY HH:mm:ss").diff(
      moment(new Date(currentFormOpenStartTime), "DD/MM/YYYY HH:mm:ss")
    );
    const d = moment.duration(ms);
    const openTime = d.minutes() || 1;
    return openTime;
  };

  async NewPatientPayment(data) {
    try {
      const result = await enrollmentServices.Invite(data);

      if (!result.data) {
        message.error("Registration Failed");
        return;
      }

      const convertUTCDate = (date, format = "MM/DD/YYYY") => {
        const d = new Date();
        date = new Date(
          moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
            " " +
            d.getHours() +
            ":" +
            d.getMinutes()
        );
        return moment(new Date(date)).utc().format(format);
      };

      const storedLoginResult = localStorage.getItem("login_result");
      const loginResultObject = storedLoginResult
        ? JSON.parse(storedLoginResult)
        : null;

      if (result.data.code === "FAILED") {
        message.error(result.data.message);
        return;
      }

      if (result.data.code === "SUCCESS") {
        let date = moment(new Date()).format("YYYYMMDDHHmmssSSS");
        let transactionId = "MT" + date;
        let appointmentDetails =
          transactionId +
          "|" +
          result.data?.responseDetails.patientId +
          "|" +
          loginResultObject.user.userId +
          "|" +
          result.data?.responseDetails.appointmentId +
          "|" +
          loginResultObject.user.account_Id +
          "|" +
          loginResultObject.user.clinic_Id;
        let base64string = Base64.encode(appointmentDetails);
        let paymentPayload = {
          // merchantId: process.env.REACT_APP_PHONEPE_MERCHANT_ID,
          merchantTransactionId: transactionId,
          // merchantUserId: "MUID123",
          amount: parseFloat(result.data.responseDetails?.totalAmount) * 100,
          redirectUrl: `${process.env.REACT_APP_BASEURL}phonepepayment/${base64string}`,
          redirectMode: "POST",
          callbackUrl: `${process.env.REACT_APP_API_BASEURL}phonePeResponse1/paymentCallBackDetails`,
          mobileNumber: result.data.responseDetails?.mobile,
          paymentInstrument: {
            type: "PAY_PAGE",
          },
        };

        const SALT_KEY = process.env.REACT_APP_PHONEPE_SALT_KEY;
        const PHONE_PE_HOST_URL = process.env.REACT_APP_PHONPE_HOST_URL;
        let bufferObj = Buffer.from(JSON.stringify(paymentPayload), "utf8");
        let base64EncodedPayload = bufferObj.toString("base64");
        let string = base64EncodedPayload + "/pg/v1/pay" + SALT_KEY;
        let sha256_val = sha256(string);
        let xVerifyChecksum = sha256_val + "###" + 1;

        let phonepeTransaction = {
          account_Id: loginResultObject.user?.account_Id,
          checksum: xVerifyChecksum,
          clinic_id: loginResultObject.user?.clinic_Id,
          createdBy: loginResultObject.user.userId,
          createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paidDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          modifiedBy: loginResultObject.user.userId,
          patientId: result.data.responseDetails?.patientId,
          enoCodePayload: base64EncodedPayload,
          providerreferenceId: "",
          serviceCode: `${
            result.data.responseDetails?.patientRegFeeYN == "Y"
              ? "APPT, REG_FEE"
              : "APPT"
          }`,
          serviceName: `${
            result.data.responseDetails?.patientRegFeeYN == "Y"
              ? "Appointment Consultation, Patient Registration Fee"
              : "Appointment Consultation"
          }`,
          status: 1,
          serviceTransId: result.data?.responseDetails.appointmentId,
          transactionId: transactionId,
          userId: loginResultObject.user.userId,
          amount: parseFloat(result.data.responseDetails?.totalAmount),
        };

        const res = await PaymentService.PhonepeTransaction(phonepeTransaction);

        if (res.data === 1) {
          let appointmentId = result.data.responseDetails?.appointmentId;
          const appointmentRes = await AppointmentService.GetAppointmentId(
            appointmentId
          );

          let appointmentUpdate = {
            appointmentId: result.data.responseDetails?.appointmentId,
            email: result.data.responseDetails?.email,
            meetingLink: result.data.responseDetails?.meetingLink,
            mobile: result.data.responseDetails?.mobile,
            id: appointmentRes.data[0].id,
            patientId: result.data.responseDetails?.patientId,
            status: 0,
            paymentReceived: "Y",
            userId: loginResultObject.user?.userId,
            createdBy: loginResultObject.user?.userId,
            modifiedBy: loginResultObject.user?.userId,
          };

          const updateRes = await AppointmentService.AppointmentUpdate(
            appointmentUpdate
          );

          let billingTransaction = {
            account_Id: loginResultObject.user?.account_Id,
            amount: result.data.responseDetails?.totalAmount,
            clinic_id: loginResultObject.user?.clinic_Id,
            createdBy: loginResultObject.user.userId,
            createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            discountAmount: 0,
            discountPercentage: 0,
            gst: 0,
            modifiedBy: loginResultObject.user.userId,
            modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            paidAmount: result.data.responseDetails?.totalAmount,
            patientId: result.data.responseDetails?.patientId,
            paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            paymode: "PhonePe",
            serviceCode: "",
            serviceCost: result.data.responseDetails?.totalAmount,
            serviceName: "",
            serviceTransId: result.data.responseDetails?.appointmentId,
            status: 0,
            transactionId: transactionId,
            userId: loginResultObject.user.userId,
            billingTransactionServices: [],
          };

          let data1 = JSON.parse(data);

          let array1 = {
            account_Id: loginResultObject.user?.account_Id,
            amount: data1.consultationFee,
            clinic_id: loginResultObject.user?.clinic_Id,
            createdBy: loginResultObject.user.userId,
            createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            fromDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            modifiedBy: loginResultObject.user.userId,
            modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            paidAmount: data1.consultationFee,
            patientId: result.data.responseDetails?.patientId,
            paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            paymode: "PhonePe",
            serviceCode: "APPT",
            serviceCost: data1.consultationFee,
            serviceName: "Appointment Consultation",
            serviceTransId: result.data.responseDetails?.appointmentId,
            status: 0,
            toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            transactionId: transactionId,
            userId: loginResultObject.user.userId,
          };
          billingTransaction.billingTransactionServices.push(array1);

          if (data1.patientRegFeeYN == "Y") {
            let array2 = {
              account_Id: loginResultObject.user?.account_Id,
              amount: data1.patientRegFee,
              clinic_id: loginResultObject.user?.clinic_Id,
              createdBy: loginResultObject.user.userId,
              createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              fromDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              modifiedBy: loginResultObject.user.userId,
              modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              paidAmount: data1.patientRegFee,
              patientId: result.data.responseDetails?.patientId,
              paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              paymode: "PhonePe",
              serviceCode: "REG_FEE",
              serviceCost: data1.patientRegFee,
              serviceName: "Patient Registration Fee",
              serviceTransId: result.data.responseDetails?.appointmentId,
              status: 0,
              toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              transactionId: transactionId,
              userId: loginResultObject.user.userId,
            };
            billingTransaction.billingTransactionServices.push(array2);
          }

          // return;

          const billingRes = await PaymentService.BillingTransaction(
            billingTransaction
          );

          if (billingRes.data === 1) {
            const configurationObject = {
              method: "POST",
              url: PHONE_PE_HOST_URL,
              data: { request: base64EncodedPayload },
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-VERIFY": xVerifyChecksum,
              },
            };
            // const paymentRes = await axios(configurationObject);
            // window.location.replace(
            //   paymentRes.data.data.instrumentResponse.redirectInfo.url
            // );
            const response = await PaymentService.initiatePayment(
              configurationObject.data
            );
            window.location.replace(response.data.PhonePeURL);
          }
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
      message.error("An error occurred:");
    }
  }

  async ExisTingPatientPayment(data) {
    try {
      const result = await enrollmentServices.Invite(data);

      if (!result.data) {
        message.error("Registration Failed, Retry");
        return;
      }

      const convertUTCDate = (date, format = "MM/DD/YYYY") => {
        const d = new Date();
        date = new Date(
          moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
            " " +
            d.getHours() +
            ":" +
            d.getMinutes()
        );
        return moment(new Date(date)).utc().format(format);
      };

      const storedLoginResult = localStorage.getItem("login_result");
      const loginResultObject = storedLoginResult
        ? JSON.parse(storedLoginResult)
        : null;

      if (result.data.code === "SUCCESS") {
        let date = moment(new Date()).format("YYYYMMDDHHmmssSSS");
        let transactionId = "MT" + date;
        let appointmentDetails =
          transactionId +
          "|" +
          result.data?.responseDetails.patientId +
          "|" +
          loginResultObject.user.userId +
          "|" +
          result.data?.responseDetails.appointmentId +
          "|" +
          loginResultObject.user.account_Id +
          "|" +
          loginResultObject.user.clinic_Id;
        let base64string = Base64.encode(appointmentDetails);
        let paymentPayload = {
          // merchantId: process.env.REACT_APP_PHONEPE_MERCHANT_ID,
          merchantTransactionId: transactionId,
          // merchantUserId: "MUID123",
          amount: parseFloat(result.data.responseDetails?.totalAmount) * 100,
          redirectUrl: `${process.env.REACT_APP_BASEURL}phonepepayment/${base64string}`,
          redirectMode: "POST",
          callbackUrl: `${process.env.REACT_APP_API_BASEURL}phonePeResponse1/paymentCallBackDetails`,
          mobileNumber: result.data.responseDetails?.mobile,
          paymentInstrument: {
            type: "PAY_PAGE",
          },
        };

        const SALT_KEY = process.env.REACT_APP_PHONEPE_SALT_KEY;
        const PHONE_PE_HOST_URL = process.env.REACT_APP_PHONPE_HOST_URL;
        let bufferObj = Buffer.from(JSON.stringify(paymentPayload), "utf8");
        let base64EncodedPayload = bufferObj.toString("base64");
        let string = base64EncodedPayload + "/pg/v1/pay" + SALT_KEY;
        let sha256_val = sha256(string);
        let xVerifyChecksum = sha256_val + "###" + 1;

        let phonepeTransaction = {
          account_Id: loginResultObject.user?.account_Id,
          checksum: xVerifyChecksum,
          clinic_id: loginResultObject.user?.clinic_Id,
          createdBy: loginResultObject.user.userId,
          createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paidDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          modifiedBy: loginResultObject.user.userId,
          patientId: result.data.responseDetails?.patientId,
          enoCodePayload: base64EncodedPayload,
          providerreferenceId: "",
          serviceCode: "APPT",
          serviceName: "Appointment Consultation",
          status: 1,
          serviceTransId: result.data?.responseDetails.appointmentId,
          transactionId: transactionId,
          userId: loginResultObject.user.userId,
          amount: result.data.responseDetails?.totalAmount,
        };

        const res = await PaymentService.PhonepeTransaction(phonepeTransaction);

        if (res.data === 1) {
          let appointmentId = result.data.responseDetails?.appointmentId;
          const appointmentRes = await AppointmentService.GetAppointmentId(
            appointmentId
          );

          let appointmentUpdate = {
            appointmentId: result.data.responseDetails?.appointmentId,
            email: result.data.responseDetails?.email,
            meetingLink: result.data.responseDetails?.meetingLink,
            mobile: result.data.responseDetails?.mobile,
            id: appointmentRes.data[0].id,
            patientId: result.data.responseDetails?.patientId,
            status: 0,
            userId: loginResultObject.user?.userId,
            paymentReceived: "Y",
            createdBy: loginResultObject.user?.userId,
            modifiedBy: loginResultObject.user?.userId,
          };

          const updateRes = await AppointmentService.AppointmentUpdate(
            appointmentUpdate
          );

          let billingTransaction = {
            account_Id: loginResultObject.user?.account_Id,
            amount: result.data.responseDetails?.totalAmount,
            clinic_id: loginResultObject.user?.clinic_Id,
            createdBy: loginResultObject.user.userId,
            createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            discountAmount: 0,
            discountPercentage: 0,
            gst: 0,
            modifiedBy: loginResultObject.user.userId,
            modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            paidAmount: result.data.responseDetails?.totalAmount,
            patientId: result.data.responseDetails?.patientId,
            paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            paymode: "PhonePe",
            serviceCode: "",
            serviceCost: result.data.responseDetails?.totalAmount,
            serviceName: "",
            serviceTransId: result.data.responseDetails?.appointmentId,
            status: 0,
            transactionId: transactionId,
            userId: loginResultObject.user.userId,
            billingTransactionServices: [],
          };

          // let data1 = JSON.parse(data);

          let array1 = {
            account_Id: loginResultObject.user?.account_Id,
            amount: data.consultationFee,
            clinic_id: loginResultObject.user?.clinic_Id,
            createdBy: loginResultObject.user.userId,
            createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            fromDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            modifiedBy: loginResultObject.user.userId,
            modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            paidAmount: data.consultationFee,
            patientId: result.data.responseDetails?.patientId,
            paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            paymode: "PhonePe",
            serviceCode: "APPT",
            serviceCost: data.consultationFee,
            serviceName: "Appointment Consultation",
            serviceTransId: result.data.responseDetails?.appointmentId,
            status: 0,
            toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            transactionId: transactionId,
            userId: loginResultObject.user.userId,
          };
          billingTransaction.billingTransactionServices.push(array1);

          const billingRes = await PaymentService.BillingTransaction(
            billingTransaction
          );

          if (billingRes.data === 1) {
            const configurationObject = {
              method: "POST",
              url: PHONE_PE_HOST_URL,
              data: { request: base64EncodedPayload },
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-VERIFY": xVerifyChecksum,
              },
            };
            // const paymentRes = await axios(configurationObject);
            // window.location.replace(
            //   paymentRes.data.data.instrumentResponse.redirectInfo.url
            // );
            const response = await PaymentService.initiatePayment(
              configurationObject.data
            );
            window.location.replace(response.data.PhonePeURL);
          }
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
      message.error(
        "An error occurred while sending invite. Please try again."
      );
    }
  }

  async FakePreConsult(appointmentDetails, setLoading) {
    setLoading(true);
    const convertUTCDate = (date, format = "MM/DD/YYYY") => {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
      return moment(new Date(date)).utc().format(format);
    };

    const storedLoginResult = localStorage.getItem("login_result");
    const loginResultObject = storedLoginResult
      ? JSON.parse(storedLoginResult)
      : null;

    let payload = {
      account_Id: loginResultObject.user.account_Id,
      clinic_Id: loginResultObject.user.clinic_Id,
      consultationDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      consultationReason: appointmentDetails.appointmentReason
        ? appointmentDetails.appointmentReason
        : "",
      consultationType: appointmentDetails?.serviceName,
      createdBy: loginResultObject.user.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      image: "",
      imageName: null,
      imageType: null,
      modifiedBy: loginResultObject.user.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientDocumentID: 0,
      patientId: appointmentDetails.patientId,
      status: 1,
      userId: loginResultObject.user.userId,
      appointmentId: appointmentDetails.appointmentId,
      specialityCode: appointmentDetails.specialityCode,
      symptoms: "",
      recommendation: "",
      followupVisitDate: "",
      patientVitals: [],
      labPrescription: [],
      drugPrescription: [],
      patientDiagnosisDetails: [],
    };


    try {
      let endResult = await ConsultationService.ConsultationNotes(payload);

      if (endResult.data.consultationId) {
        let aptPayload = {
          appointmentId: appointmentDetails.appointmentId,
          userId: loginResultObject.user.userId,
        };

        let appointmentDetails1 = await AppointmentService.AppointmentFilter(
          aptPayload
        );
        return appointmentDetails1.data[0];
      }
    } catch (error) {
      console.error(error);
      message.error("An Error Occured try again");
      setLoading(false);
    }
  }
}

export default new commonFunctions();
